import { create } from 'apisauce';
import config from '../config';

const api = create({
  baseURL: config.API_URL,
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json'
  },
  timeout: 30000
});

class TenantsApi {
  static getDetails() {
    return api.get(`/tenants/x`);
  }
}

export default TenantsApi;



// WEBPACK FOOTER //
// ./src/api/tenantsApi.js